import { connect } from 'react-redux'
import { state_update } from '../actions'
import AiImageBig from './AiImageBig'
import imageLogic from '../reducers/imageLogic'
import { INITIAL_ZALES_IMG_URL,INITIAL_KAY_IMG_URL,INITIAL_KAY_IMG_URL61,INITIAL_KAY_IMG_URL62,INITIAL_KAY_IMG_URL2,DEFAULT_KJ_QSKU2}  from '../constants'
//import { DEFAULT_KJ_QSKU2}  from '../constants'
import {crossurl} from '../reducers/reducer.js'

function getViews (state,size){
  //console.log('Big Image',state)
  //if (state['zalessku'] !== ''){return ['']}
  if (state['initial'] === 'yes'){
    if (  window.testAB==='C'){
      if(document.documentElement.clientWidth  < document.documentElement.clientHeight)
      return [INITIAL_KAY_IMG_URL61]
    else  
      return [INITIAL_KAY_IMG_URL62]
    }
  else
  {
          if (window.currentSite ==='zales')
        return [INITIAL_ZALES_IMG_URL]
      else  
        { if (state['initial-qsku'] === DEFAULT_KJ_QSKU2)
        {
        //  console.log('Image',INITIAL_KAY_IMG_URL)
          return [INITIAL_KAY_IMG_URL2]
        }
        else 
        {
        //  console.log('Image2',INITIAL_KAY_IMG_URL2,state['initial'],DEFAULT_KJ_QSKU)
        return [INITIAL_KAY_IMG_URL]
      }
  }
  
  }
} 
  let slide_init=[]
     for (let i=1;i<=state['max_view'];i++) {
      // let extra_label = ''
      // if (state.hasOwnProperty('extra_label_view_' + i.toString()) ){
      //   extra_label='&extra='+state['extra_label_view_' + i.toString()]
      // } 
      slide_init.push(imageLogic(state,i)+'&s='+size.toString() )
     }
     if ([1,2].includes(state['cross1'])) {
      slide_init.push(crossurl[0][state['cross1']]+'&s='+size.toString())
     }
     if ([1,2].includes(state['cross2'])) {
      slide_init.push(crossurl[1][state['cross2']]+'&s='+size.toString())
     }
     if ([1,2].includes(state['cross3'])) {
      slide_init.push(crossurl[2][state['cross3']]+'&s='+size.toString())
     }
     //console.log('active_view', state['active_view'])
     //console.log('max views', viewct)
    // console.log('url done',slide_init,state)
  return slide_init    
}
const mapStateToProps = (state, ownProps) => { 
  var viewct = state['max_view']
  if ([1,2].includes(state['cross1'])) {
    viewct += 1
   }
   if ([1,2].includes(state['cross2'])) {
    viewct += 1
   }
   if ([1,2].includes(state['cross3'])) {
    viewct += 1
   }
  //let cur_image_url
  //let sku

  //let cur_image_url =imageLogic(state);
  //console.log('url done',state['sku'])
  return {
    max_views: state['max_view'],
    active_view: state['active_view'],
    view_image_base: imageLogic(state),
    slidesZoom:getViews(state,1000),
    slides:getViews(state,500),
    thumb:getViews(state,200),
    views:viewct,
    cross1:state.cross1!==0,
    cross2:state.cross2!==0,
    cross3:state.cross3!==0,
    orientation:ownProps.orientation,
    pushOpenBox:state.pushOpenBox === true ? true :false,
    type: state['type']
  }
}

 

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadDefault: ( (cat) => {//console.log(cat);
    dispatch(state_update({attr:'default', value:cat}))}),
  onChange: ( (value) => {
    console.log('dispatch state update', value+1)
    //console.log(state['active_view'])
    dispatch(state_update({attr:'active_view',value:(value+1)}))
  }),
onCloseOpenBox: ( () => {
      //console.log('close OpenBox')
      dispatch(state_update({attr:'pushOpenBox',value:false}))
    }),
  onOpenOpenBox: ( type => {
      //console.log('close OpenBox')
      if (type !== '0')
        dispatch(state_update({attr:'pushOpenBox',value:true}))
    })
 
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiImageBig)


// WEBPACK FOOTER //
// ./src/layout/AiImageBigWrap.js